import {
  HEADER_SIO_INIT,
  HEADER_SIO_INIT_SUCCESS,
} from "./actionTypes"

import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
} from "../../auth/login/actionTypes";

const initialState = {
  sio: null,
  sioLive: false,
}

const Header = (state = initialState, action) => {
  switch (action.type) {
    case HEADER_SIO_INIT:
      state = {
        ...state,
        sio: null,
      }
      break
    case HEADER_SIO_INIT_SUCCESS:
      state = {
        ...state,
        sio: action.payload,
        sioLive: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        sio: null,
        sioLive: false,
      }
      break
    case LOGOUT_SUCCESS:
      state = {
        ...state,
        sio: null,
        sioLive: false,
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default Header
